/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestGoldfinchSeniorPool extends Contract<ITestGoldfinchSeniorPool> {
  config: Call<() => string, ITestGoldfinchSeniorPool>
  'config()': Call<() => string, ITestGoldfinchSeniorPool>
  sharePrice: Call<() => BigNumber, ITestGoldfinchSeniorPool>
  'sharePrice()': Call<() => BigNumber, ITestGoldfinchSeniorPool>
}

let ITestGoldfinchSeniorPoolBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestGoldfinchSeniorPoolBytecode = '0x';
}

// prettier-ignore
export const ITestGoldfinchSeniorPool = contract<ITestGoldfinchSeniorPool>(ITestGoldfinchSeniorPoolBytecode)`
  function config() view returns (address config_)
  function sharePrice() view returns (uint256 price_)
`;